import React, { useState, useEffect } from "react";

const texts = ["empathy", "connection", "innovation", "efficiency", "integrity", "quality", "gratitude"];

const TypingEffect = () => {
  const [index, setIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const typingSpeed = 100; // Typing speed in ms
  const deleteSpeed = 50; // Deleting speed in ms
  const pauseTime = 1500; // Pause time before switching words

  useEffect(() => {
    const currentText = texts[index];
    let timer;

    if (!isDeleting) {
      // Typing effect: add letters
      if (displayText.length < currentText.length) {
        timer = setTimeout(() => {
          setDisplayText(currentText.substring(0, displayText.length + 1));
        }, typingSpeed);
      } else {
        // Pause before deleting
        setTimeout(() => setIsDeleting(true), pauseTime);
      }
    } else {
      // Backspacing effect
      if (displayText.length > 0) {
        timer = setTimeout(() => {
          setDisplayText(currentText.substring(0, displayText.length - 1));
        }, deleteSpeed);
      } else {
        // Move to next text
        setIsDeleting(false);
        setIndex((prev) => (prev + 1) % texts.length);
      }
    }

    return () => clearTimeout(timer);
  }, [displayText, isDeleting]);

  return (
    <h2 className="text-3xl font-bold text-center text-blue-400" style={{display: 'inline'}}>
      {displayText}
      <span className="animate-blink">|</span> {/* Blinking Cursor */}
    </h2>
  );
};

export default TypingEffect;
